// Cancellation policy catalog.
//
// 2026-07-02 (owner decision, cancellation-policy unification — see
// docs/design/cancellation-policy-unification.md): Merrily applies ONE
// universal policy, matching what the refund engine actually executes
// (server/api-util/lineItems.js CANCELLATION_TIERS). The 4-bucket
// host-choice model below is LEGACY: the POLICIES wizard step was
// removed (#169), nothing writes publicData.cancellation_policy
// anymore, and the listing page no longer honors stored overrides.
// The bucket entries are kept only so stored add-on row data keeps
// validating (editListingHelpers).

// The single policy every surface renders. The timing tiers MUST stay
// in sync with CANCELLATION_TIERS in server/api-util/lineItems.js —
// that engine is the money truth this copy describes.
export const UNIVERSAL_CANCELLATION_POLICY = {
  key: 'standard',
  label: 'Standard',
  summary:
    'Full refund 7+ days before pickup. 50% refund of the rental 3–7 days before. The rental is non-refundable within 3 days of pickup. Delivery fees and your deposit are always returned.',
  rules: [
    { hoursBeforeEvent: 7 * 24, refundPercent: 100 },
    { hoursBeforeEvent: 3 * 24, refundPercent: 50 },
    { hoursBeforeEvent: 0, refundPercent: 0 },
  ],
};

export const CANCELLATION_POLICIES = [
  {
    key: 'flexible',
    label: 'Flexible',
    summary:
      'Full refund up to 24 hours before the event. 50% refund after that, up to 12 hours before.',
    rules: [
      { hoursBeforeEvent: 24, refundPercent: 100 },
      { hoursBeforeEvent: 12, refundPercent: 50 },
      { hoursBeforeEvent: 0, refundPercent: 0 },
    ],
  },
  {
    key: 'moderate',
    label: 'Moderate',
    summary:
      'Full refund 14+ days before the event, 50% refund 7–14 days before, no refund within 7 days.',
    rules: [
      { hoursBeforeEvent: 14 * 24, refundPercent: 100 },
      { hoursBeforeEvent: 7 * 24, refundPercent: 50 },
      { hoursBeforeEvent: 0, refundPercent: 0 },
    ],
  },
  {
    key: 'strict',
    label: 'Strict',
    summary:
      'Full refund 30+ days before the event, 50% refund 14–30 days before, no refund within 14 days.',
    rules: [
      { hoursBeforeEvent: 30 * 24, refundPercent: 100 },
      { hoursBeforeEvent: 14 * 24, refundPercent: 50 },
      { hoursBeforeEvent: 0, refundPercent: 0 },
    ],
  },
  {
    key: 'non_refundable',
    label: 'Non-refundable',
    summary: 'No refunds after booking is confirmed.',
    rules: [{ hoursBeforeEvent: 0, refundPercent: 0 }],
  },
];

export const CANCELLATION_POLICY_KEYS = CANCELLATION_POLICIES.map(p => p.key);

/**
 * Returns the policy entry by key, or null if unknown.
 */
export const findCancellationPolicy = key =>
  CANCELLATION_POLICIES.find(p => p.key === key) || null;

/**
 * Default fallback for listings without a saved policy. Matches the
 * locked enum but errs on the side of letting hosts choose — we
 * surface "Moderate" as the default label when no value is set, but
 * the host has to actively pick before publishing (POLICIES step's
 * Next button is gated on a value being chosen).
 */
export const DEFAULT_CANCELLATION_POLICY_KEY = 'moderate';
